module.exports = __webpack_public_path__ + "static/media/lily-collins-icon.357ef23d.jpg";